export default function generateTitle(title) {
    return `${title} | Pennygemapp`;
}
